"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.action('REMOVE_MESSAGEAD_CLEAR_LIST', function (removeAdId) {
    return {
        removeAdId: removeAdId,
    };
});
//# sourceMappingURL=removeMessageAdClearList.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-messagead-store/lib/actions/removeMessageAdClearList.js
// module id = 3461
// module chunks = 17 67